import { Observable } from "@dooboostore/core";
import { AutoCloseSubscription } from "@dooboostore/core";
var AnimationFrameUtils;
((AnimationFrameUtils2) => {
  function fps(params, callback) {
    let startTimestamp = null;
    let stop = false;
    const animate = (currentTimestamp) => {
      if (startTimestamp !== null) {
        const delta = currentTimestamp - startTimestamp;
        const fps2 = (params?.second ?? 1) * 1e3 / delta;
        callback({ fpsConfigParam: params, fps: fps2, startTimestamp, timestamp: currentTimestamp });
      }
      startTimestamp = currentTimestamp;
      if (!stop) {
        window.requestAnimationFrame(animate);
      }
    };
    window.requestAnimationFrame(animate);
    return new AutoCloseSubscription(() => stop = true);
  }
  AnimationFrameUtils2.fps = fps;
  AnimationFrameUtils2.dividePerFpsObservable = ({
    fpsConfig,
    divideSize
  }) => {
    return new Observable((subscriber) => {
      const handler = (event) => subscriber.next(event);
      let fps2 = 0;
      const getDrawFpsGap = () => {
        return Math.floor(fps2 / divideSize);
      };
      let gapPosition = 0;
      const fpsSubscription = AnimationFrameUtils2.fps(fpsConfig, (fpsConfig2) => {
        fps2 = fpsConfig2.fps;
        gapPosition++;
        const gapSize = getDrawFpsGap();
        if (gapPosition >= gapSize) {
          handler({ ...fpsConfig2, ...{ gapPosition, gapSize } });
          gapPosition = 0;
        }
      });
      return () => {
        fpsSubscription.unsubscribe();
      };
    });
  };
})(AnimationFrameUtils || (AnimationFrameUtils = {}));
export {
  AnimationFrameUtils
};
//# sourceMappingURL=AnimationFrameUtils.js.map
